<template>
  <div id="container" class="flex">
    <div class="full_layout" v-loading='loading'>
      <div class="callbackBox">
        <div class="callbackTitle" v-if="isUserAuth!=2&&isUserAuth!=0">
          <span class="text_blue" v-if="isUserAuth==1">{{$t('base.processing')}}</span>
          <span class="text_yellow" v-if="isUserAuth==3">{{$t('enum.declined')}}</span>
        </div>
        <p v-if="isUserAuth==0">{{$('kyc.verifyyouridentity')}}
        </p>
        <p v-if="isUserAuth==3">{{$('kyc.Verifyfailed')}}
        </p>
        <!-- <div v-if="isUserAuth==1">{{$t('base.processing')}}</div> -->
      </div>
      <div class="footerBtn">
        <el-button type="primary" size="small" @click="SetIDVerification()">Return to Personal Info</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    return {
      loading: true,
      isUserAuth: '',
      userInfo: null,
      title: this.$t('kyc.IDVerification'),
      isPC: false
    }
  },
  created() {
    // if (this.$route.path == "/terms/authentication") {
    //   this.isPC = true
    //   this.userInfo=getInfo()
    //   this.getQueryUserAuth()
    // }else{
    //   this.pcShow()
    // }
      //this.isPC = true
      this.userInfo=getInfo()
      //this.getQueryUserAuth()
  },
  mounted() {
    this.$store.commit('SET_HEADER_TITLE', this.title);
    this.getQueryUserAuth()
  },
  methods: {
    // pcShow() {
    //   let that = this
    //   let ua = navigator.userAgent.toLowerCase();
    //   if (ua.indexOf('windows') > -1 || ua.indexOf('intel mac os') > -1) {
    //     that.isPC = true
    //     that.$router.push({
    //       path: '/terms/authentication'
    //     })
    //   }else{

    //   }
    // },
    getQueryUserAuth() {
      let that = this
      let title = that.title
      if (that.userInfo.VerifyStatus == 2) {} else {
        let that = this
        that.$get(that.$interface.QueryUserAuth, { Id: that.userInfo.MappingUserId }).then(res => {
          if (res.Result) {
            that.isUserAuth = res.Data
          }
          that.loading = false

        })
      }
    },
    SetIDVerification() {
      let that=this
      that.$router.push({
          path: '/mycardhobby/setting'
        })
      // if(that.isPC){
      //   that.$router.push({
      //     path: '/mycardhobby/setting'
      //   })
      // }else{
      //   let ua = navigator.userAgent.toLowerCase();
      //   let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1|| ua.indexOf('android') > -1|| ua.indexOf('adr') > -1;
      //   let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      //   let data = {"status": 0 }
      //   if (!isAndroid) {
      //     try {
      //     window.webkit.messageHandlers.KycCallback.postMessage(data)
      //   } catch (error) {
      //     console.log('WKWebView post message');
      //   }
      //   } else if(isAndroid){
      //     android.KycCallback(JSON.stringify(data));  
      //   }
      // }
    }
  }
}

</script>
<style scoped>
  .flex{
    flex:1;
  }
.full_layout {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
}

.callbackBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.callbackTitle {
  font-size: 36px;
  margin-bottom: 50px;
  font-weight: 700;
}

.callbackBox p {
  font-size: 24px;
}

.footerBtn {
  margin: 0 auto 70px;
}

.footerBtn .el-button {
  font-size: 20px;
}

.powerJumio {
  display: flex;
  justify-content: center;
  color: #a0a0a0;
  margin-bottom: 20px;
}

.powerJumio:before {
  content: '';
  height: auto;
  width: 45px;
  background: url(/static/images/icon/icon_logo_jumio.png) no-repeat;
  background-size: contain;
}

.appAuth{
      height: 100vh;
    width: 100%;
    overflow: hidden;    display: flex;
    flex-direction: column;
}
.appAuth .processing{
  display: flex;
  width: 40vw;
  height: 40vw;
  color: #fff;
  font-size: 24px;
  justify-content: center;
  align-items: center;
  margin: 200px auto 20px;
  border-radius: 40vw;
  background-color: #5F6DAE;
}
.appAuth .el-button {
  text-align: center;    margin: 50px auto;
}

</style>



// WEBPACK FOOTER //
// src/components/authenticationcallback.vue